/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { parseHtml, getId, subscribe, unsubscribe } from './twd'
import { usePopper  } from 'react-popper'
import { mediaQueries } from './media-queries'

export const Flyout = ({
    label="",
    ariaLabel="",
    html="",
    dataName="",
    className='btn-label btn-flyout',
    popperStyles={
        maxWidth:`${Math.min(mediaQueries.width()-40, 300)}px`,
    },
    contentStyle={
        width: '300px'
    },
    isLabel=false,
    labelAttrs={},
    labelStyle={
        display:'inline'
    },
    showIcon=true,
    iconName="info_outline",
    iconCls="text-muted material-icons",
    iconStyle={},
    isButton=true,
    disabled=false,
    onClick=null,
    placement="top",
    strategy="fixed",
    trackMouseOnTip=true,
    trigger=['click'],
    anchorEl=null,
    autoShow=false,
    onShow=(() => {}),
    onHide=(() => {}),
}) => {
    const [show, setShow] = React.useState(false)
    const [btnEl, setBtnEl] = React.useState(anchorEl)
    const [iconEl, setIconEl] = React.useState(null)
    const [popEl, setPopEl] = React.useState(null)
    const [arrEl, setArrEl] = React.useState(null)
    const [elId] = React.useState(getId())

    const {styles, attributes, state} = usePopper(
        showIcon ? iconEl : btnEl,
        popEl,
        {
            placement,
            strategy,
            modifiers: [{
                name: 'arrow',
                options: { element: arrEl}
            }, {
                name: 'flip',
                options: {
                    fallbackPlacements: ['top', 'bottom']
                }
            }, {
                name: 'preventOverflow',
                options: {
                    enabled: true,
                    boundariesElement: 'window'
                }
            }]
        },
    )

    const doShow = (val) => {
        if (!val) {
            btnEl.removeAttribute('mouse-on-tip')
            btnEl.removeAttribute('mouse-on-button')
            btnEl.removeAttribute('focus-on-button')
        }
        setShow(val)

        if (anchorEl) {
            if (val) {
                anchorEl.setAttribute('aria-controls', elId)
            } else {
                anchorEl.removeAttribute('aria-controls')
            }
        }
    }

    React.useEffect(() => {
        let subId = subscribe('hide_flyout', () => {
            setShow(false)
        })
        return () => {
            unsubscribe(subId)
        }
    }, [setShow])

    const showFn = () => { setTimeout(() => doShow(true)) }
    const hideFn = () => { setTimeout(() => {
        const f = btnEl.hasAttribute('mouse-on-tip')
            || btnEl.hasAttribute('mouse-on-button')
            || btnEl.hasAttribute('focus-on-button')
        if (f) return

        doShow(false)
    }, 100) }

    React.useEffect(() => {
        if (!popEl) return

        if (show) {
            onShow({contentEl:popEl})
        } else {
            onHide()
        }
    }, [show, popEl])

    React.useEffect(() => {
        if (!show || !popEl) return

        const hasClick = trigger.includes('click')
        setTimeout(() => {
            const focusEl = hasClick ? btnEl : popEl
            focusEl.focus()
        })

        const addFn = popEl.addEventListener.bind(popEl)
        const keydownFn = (ev) => {
            if (ev.key!=='Escape') return
            ev.stopPropagation()
            doShow(false)
        }
        addFn('keydown', keydownFn)

        const popEnterFn = () => {
            btnEl.setAttribute('mouse-on-tip', 'true')
        }
        const popLeaveFn = () => {
            btnEl.removeAttribute('mouse-on-tip')
            hideFn()
        }
        if (trackMouseOnTip) addFn('mouseenter', popEnterFn)
        if (trackMouseOnTip) addFn('mouseleave', popLeaveFn)


        const clickFn = (ev) => {
            if (popEl.contains(ev.target)) return
            doShow(false)
        }
        document.addEventListener('click', clickFn)

        return () => {
            const remFn = popEl.removeEventListener.bind(popEl)
            remFn('keydown', keydownFn)
            if (trackMouseOnTip) remFn('mouseenter', popEnterFn)
            if (trackMouseOnTip) remFn('mouseleave', popLeaveFn)

            document.removeEventListener('click', clickFn)
        }
    }, [show, btnEl, popEl])


    React.useEffect(() => {
        if (!btnEl) return

        const hasClick = trigger.includes('click')
        const hasHover = trigger.includes('hover')
        const hasFocus = trigger.includes('focus')

        const addFn = btnEl.addEventListener.bind(btnEl)

        const keydownFn = (ev) => {
            if (ev.key==='Escape') {
                ev.stopPropagation()
                doShow(false)
            }
            else if (ev.key==='Tab') {
                doShow(false)
            }
        }
        addFn('keydown', keydownFn)

        const clickFn = (ev) => {
            const curr = btnEl.getAttribute('aria-expanded') === 'true'
            setTimeout(() => doShow(!curr))
        }
        if (hasClick) { addFn('click', clickFn) }

        const focusFn = () => {
            btnEl.setAttribute('focus-on-button', 'true')
            showFn()
        }
        const blurFn = () => {
            btnEl.removeAttribute('focus-on-button')
            hideFn()
        }
        if (hasFocus) { addFn('focus', focusFn) }
        if (hasFocus || hasHover) { addFn('blur', blurFn) }


        const mouseOverFn = () => {
            btnEl.setAttribute('mouse-on-button', 'true')
            showFn()
        }
        const mouseOutFn = () => {
            btnEl.removeAttribute('mouse-on-button')
            hideFn()
            setTimeout(() => btnEl.focus())
        }
        if (hasHover || hasFocus) { addFn('mouseover', mouseOverFn) }
        if (hasHover || hasFocus) { addFn('mouseout', mouseOutFn) }


        return () => {
            const remFn = btnEl.removeEventListener.bind(btnEl)
            remFn('keydown', keydownFn)
            if (hasClick) { remFn('click', clickFn) }
            if (hasFocus) { remFn('focus', focusFn) }
            if (hasFocus || hasHover) { remFn('blur', blurFn) }
            if (hasHover) { remFn('mouseover', mouseOverFn) }
            if (hasHover) { remFn('mouseout', mouseOutFn) }
        }
    }, [btnEl])

    const Tag = `${isButton ? 'button' : 'a'}`
    const showBtn = !anchorEl
    const LabelTag = `${isLabel ? 'label' : 'span'}`
    const canExpand = trigger.includes('click') || trigger.includes('focus')

    React.useEffect(() => {
        if (!autoShow) return

        setTimeout(() => { doShow(true) })
    }, [])

    return <React.Fragment>
        {showBtn && <Tag
            ref={setBtnEl}
            aria-label={ariaLabel || (label && (`${label} information`)) || 'information'}
            { ...(canExpand && {"aria-expanded":show }) }
            { ...(isButton && {type:"button"}) }
            trigger={trigger.join(',')}
            className={className}
            disabled={disabled}
            aria-controls={elId}
            { ...(isButton ? {} : {href:"#"}) }
            { ...(onClick && {onClick})}
            data-name={dataName}
        >
            {label && <LabelTag style={labelStyle} {...labelAttrs}>{label}</LabelTag>}
            {showIcon && <i
                ref={setIconEl}
                className={iconCls}
                aria-hidden="true"
                style={Object.assign({
                    marginTop: '-3px',
                    fontSize: '15px',
                    textDecoration: 'none',
                    verticalAlign: 'middle',
                    marginLeft: '5px',
                    position: 'relative',
                }, iconStyle)}
            >{iconName}</i>}
        </Tag>}

        {show && <div
            ref={setPopEl}
            className={`flyout ${show ? "in " : ""} fade popover react-popover ${(state && state.placement) || placement}`}
            style={{
                ...popperStyles,
                ...styles.popper}}
            {...attributes.popper}
        >
            <div
                ref={setArrEl}
                className={`arrow`}
                style={styles.arrow}></div>
            <div
                id={elId}
                className="popover-content"
                style={contentStyle}
                role="tooltip"
            >
                { typeof html === 'string'
                    ? <div style={{minHeight:'22px'}} dangerouslySetInnerHTML={{__html:parseHtml(html)}} />
                    : html
                }
            </div>
        </div>}
    </React.Fragment>
}
